import { imageHelper } from "../../shared/helpers/imageHelper";
import empty from "../../static/1x1_trans.png";
import "./ProductImage.scss";

interface ProductImageProps {
  alt?: string;
  height: number;
  localSrc: string;
  width: number;
}

const ProductImage = ({
  alt = "",
  height,
  localSrc,
  width,
}: ProductImageProps) => {
  const getImageUrl = (localImage: string): string => {
    if (!localImage) {
      return empty;
    }
    return localImage;
  };

  return (
    <img
    className="object-fit"
      alt={alt}
      width={`${width}`}
      height={`${height}`}
      src={getImageUrl(localSrc)}
    />
  );
};

export default ProductImage;
